import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { isExpoPath } from '@/features/auto-test/expo/routes'
import { isShowcasePath } from '@/features/auto-test/showcase/routes'

export function PortalFonts() {
  const { pathname } = useLocation()
  const showcase = isShowcasePath(pathname) || isExpoPath(pathname)

  useEffect(() => {
    if (showcase) return
    // Preserve the existing portal fonts, but keep the kiosk entry CDN-free.
    const links = [
      'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap',
      'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200',
    ].map(href => {
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = href
      document.head.append(link)
      return link
    })
    return () => { for (const link of links) link.remove() }
  }, [showcase])

  return null
}
